import { useGetApiDataAsMutate } from "shared/datalayer";
import { ApiTicketsPage } from "shared/types/ApiTicketsPage";
import PublicApi from "shared/enums/PublicApi";

/**
 * @name useGetFormsList
 * @description This is used to get list of available forms for a coupon code
 * @param regId
 * @param couponCode
 * @todo move type to common file
 */

export function useGetFormsListForCouponCode() {
  return useGetApiDataAsMutate<ApiTicketsPage>(PublicApi.REGISTRATION_FORMS_LIST, {
    clientOptions: { displayErrorMessage: false }
  });
}
